import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IResponsibilityType } from '../interfaces/IResponsibilityType';

export async function fetchResponsibilityTypes(): Promise<IResponsibilityType[]> {
  return apiGet<IResponsibilityType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/erknm/responsibility-type`,
  );
}
